var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-model"},[(!_vm.loading)?_c('div',{ref:"printMe",attrs:{"id":"printMe"}},[_c('SalesPayments',{attrs:{"item":_vm.item}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }